module.exports = __webpack_public_path__ + "static/media/osviel-simbolo.a1fc39bf.png";